import React from 'react';
import { bool, func, shape } from 'prop-types';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { ExportButton, FullScreenButton, ResetButton } from './GridToolbarButtons';

const GridToolbar = ({
  onResetView,
  onExportClick,
  isExporting,
  hideExportButton,
  disabledExport,
  exportOptions,
  showFilterButton,
  quickFilter,
  showFullScreenButton,
  isFullScreen,
  onFullScreenToggle,
}) => {
  return (
    <GridToolbarContainer sx={{ width: '100%' }}>
      <GridToolbarColumnsButton disabled={isExporting} variant="dataTable" />
      {showFilterButton && <GridToolbarFilterButton disabled={isExporting} variant="dataTable" />}
      <GridToolbarDensitySelector disabled={isExporting} variant="dataTable" />
      {!hideExportButton &&
        (onExportClick ? (
          <ExportButton
            disabled={isExporting || disabledExport}
            isExporting={isExporting}
            onExportClick={onExportClick}
          />
        ) : (
          <GridToolbarExport {...exportOptions} startIcon={<DownloadIcon />} variant="dataTable" />
        ))}
      <ResetButton disabled={isExporting} onResetView={onResetView} />
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexGrow: 1,
          gap: 1,
          justifyContent: 'flex-end',
        }}
      >
        {quickFilter && (
          <GridToolbarQuickFilter disabled={isExporting} sx={{ pb: 0 }} variant="outlined" />
        )}
        {showFullScreenButton && (
          <FullScreenButton
            disabled={isExporting}
            isFullScreen={isFullScreen}
            onFullScreen={onFullScreenToggle}
          />
        )}
      </Box>
    </GridToolbarContainer>
  );
};

GridToolbar.propTypes = {
  disabledExport: bool,
  exportOptions: shape({}),
  hideExportButton: bool,
  isExporting: bool,
  isFullScreen: bool,
  onExportClick: func,
  onFullScreenToggle: func,
  onResetView: func.isRequired,
  quickFilter: bool,
  showFilterButton: bool,
  showFullScreenButton: bool,
};

GridToolbar.defaultProps = {
  disabledExport: false,
  exportOptions: null,
  hideExportButton: false,
  isExporting: false,
  isFullScreen: false,
  onExportClick: null,
  onFullScreenToggle: null,
  quickFilter: false,
  showFilterButton: false,
  showFullScreenButton: false,
};

export default GridToolbar;
